<template>
  <ul
    v-if="dots.length"
    class="w-full py-4 flex justify-center gap-2.5 flex-wrap list-none lg:hidden"
  >
    <SimpleCarouselDotNavigationItem
      v-for="(item, index) in dots"
      :key="`dot-${index}`"
      :class="index === currentSlide ? 'bg-EXPONDO-grey-60' : 'bg-EXPONDO-grey-10'"
      @click="dotClick(index)"
    />
  </ul>
</template>
<script lang="ts">

export default defineComponent({
  name: 'SimpleCarouselDotNavigation',

  props: {
    dots: {
      type: Array,
      required: true,
    },
    currentSlide: {
      type: Number,
      default: 0,
    },
  },
  emits: ['dotClicked'],
  setup(_props, { emit }) {

    const dotClick = (index: number) => {

      emit('dotClicked', index);
    
    };

    return {
      dotClick,
    };
  
  },
});

</script>
